module.exports = __webpack_public_path__ + "static/banner-78ffe2578381c09ce0748f3537f6ccd8.gif";